import useState from 'react-usestateref';

export default function InfoTip({ keyword, onLoad }) {
  const [visible, setVisible] = useState(false);
  const loadDoc = async (keyword) => {
    console.log("keyword::1",keyword)
    try {
      //const doc = await import(`/docs/${keyword}.md`);
      console.log("doc::1",`/docs/${keyword}.md`)
      const res = await fetch(`/docs/${keyword}.md`);
      return await res.text();
    } catch (err) {
      console.log("# Documentation not found");
    }
  }

  const handleClick = async () => {
    console.log("document")
    const markdown = await loadDoc(keyword);
    onLoad(markdown);
    setVisible(!visible);
  };


  return (
    <span
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        color: '#16a34a',
        fontWeight: 'bold',
        fontSize: '12px',          // smaller font size
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '6px',
        userSelect: 'none',
        backgroundColor: 'transparent',
      }}
    >
      info
    </span>
  );
}